import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxChartsModule } from '@swimlane/ngx-charts';

import { VentaMarcaChartComponent } from './venta-marca-chart.component';

@NgModule({
  imports:      [ 

    FormsModule,
    NgxChartsModule
],
  exports: [VentaMarcaChartComponent],
  declarations: [ VentaMarcaChartComponent ],
  bootstrap:    [ VentaMarcaChartComponent ]
})
export class VentaMarcaChartModule { }
